import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/page";
import PagePublicSchema from "@common/schema/page/public";
import * as Section from "@repoflow/components/section";
import { Crumb, useCrumbLabel } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as EditRoute from "./edit";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { pageId },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${pageId}`;
  const basepath = `${parentBasepath}/:pageId`;

  return (
    <Section.Provider
      // One schema, because a page owns nothing. Everything under this section
      // resolves its widgets out of this context, so if a child listing is ever
      // added its schema belongs here rather than there.
      schema={PagePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      <Children base={base} basepath={basepath} params={params} />
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={params}
          datapath={"pages.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

// The id is generated and says nothing; the title is what the page is called
// everywhere else on the screen.
function PageCrumb({ base, pageId }) {
  const label = useCrumbLabel({
    query: QueriesQL.get,
    variables: { pageId },
    datapath: "pages.get.title",
    fallback: pageId,
  });

  return <Crumb to={`${base}`} label={label} />;
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { pageId } }) => (
        <>
          <PageCrumb base={base} pageId={pageId} />

          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => (
  <>
    <EditRoute.Sidebar />
    <ViewRoute.Sidebar />
  </>
);
